/*
 * @Date: 2023-02-14 09:56:13
 * @LastEditTime: 2026-01-31 10:00:00
 * @Description: 通用API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 文件上传
  uploadImage(data) {
    return request({
      url: "/file/uploadImage",
      method: "post",
      data: data,
    });
  },
  // 获取轮播图
  getBannerList(data) {
    return request({
      url: "/banner/getBannerList?" + parameterChange(data),
      method: "get",
      data: data,
    });
  },
  // 课类下拉列表
  classifyList(data) {
    return request({
      url: "/classify/classifyList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 标签下拉列表
  tagList(data) {
    return request({
      url: "/tag/tagList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 标签列表（分页）
  tagPageList(data) {
    return request({
      url: "/tag/tagList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 类别下拉列表
  getCategoryList(data) {
    return request({
      url: "/category/categoryList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
  // 首页列表
  getCourseList(data) {
    return request({
      url: "/homepage/getCourseList?" + parameterChange(data),
      method: "get",
      data: data,
    });
  },
  // 热门课程
  getHotCourse(data) {
    return request({
      url: "/play_history/getHotCourse?" + parameterChange(data),
      method: "get",
      data: data,
    });
  },
  // 项目课程列表
  getProjectCoursePageList(data) {
    return request({
      url: "/project/getProjectCoursePageList?" + parameterChange(data),
      method: "get",
      data,
    });
  },
};
